import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Seo from "@/shop/Seo";
import { apiGet } from "@/shop/api";
import ProductCard from "@/components/shop/ProductCard";

export default function ArchiveList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    apiGet("/api/shop/products?product_type=archive&sort=newest")
      .then((d) => {
        setItems(d);
        if (d.length) window.posthog?.capture("archive_view", { count: d.length });
      })
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-ink text-bone min-h-screen" data-testid="archive-list">
      <Seo
        title="Archive — Stillwater"
        description="Pezzi rari, fuori produzione e interessanti dalla riva: mulinelli storici, tackle modificati, oggetti unici della storia del carpfishing."
        canonical="https://stillwatermag.eu/shop/archive"
      />
      <header className="px-5 md:px-10 pt-28 md:pt-36 pb-10 md:pb-16 border-b border-ink-border">
        <p className="font-mono text-[10px] md:text-xs uppercase tracking-[0.35em] text-ember mb-4">
          Shop — Archivio
        </p>
        <h1 className="font-serif font-light text-4xl md:text-6xl tracking-tight">
          Stillwater <span className="italic text-ember">Archive</span>
        </h1>
        <p className="mt-4 max-w-xl text-sm md:text-base text-mist leading-relaxed">
          "Oggetti rari, fuori produzione e interessanti dalla riva." Di
          solito un pezzo per volta: quando va via, resta raccontato.
        </p>
      </header>

      <div className="px-5 md:px-10 py-12">
        {!loading && items.length === 0 && (
          <div className="border border-ink-border bg-ink-surface px-6 py-16 text-center" data-testid="archive-empty">
            <p className="font-serif italic text-2xl">L'archivio è chiuso, per ora.</p>
            <p className="mt-3 text-sm text-mist">
              I primi oggetti rari arriveranno presto, uno alla volta.
            </p>
          </div>
        )}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-7">
          {items.map((p, i) => (
            <motion.div
              key={p.id}
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: (i % 6) * 0.07, ease: [0.16, 1, 0.3, 1] }}
            >
              <ProductCard p={p} />
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
